import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CARE_STEPS } from "../../constants/data";
import { SectionHeading, Reveal } from "../Reveal";

export const CareProcess = () => (
  <section id="process" data-testid="care-process-section" className="py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHeading title="Plan that fits Needs" />
            <Reveal delay={0.15}>
              <p className="mt-6 text-lg leading-relaxed text-slate-600 max-w-md">
                Every relationship begins with listening. Our six-step process ensures care that is personal, dependable, and always centred on the individual — from the first conversation to ongoing quality reviews.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <Link
                to="/contact"
                data-testid="process-consultation-cta"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-navy px-6 py-3.5 text-base font-bold text-white hover:bg-brand-teal transition-colors duration-300 active:scale-95"
              >
                Start with a Free Consultation
              </Link>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-5">
          {CARE_STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`process-step-${step.num}`}
              className="relative overflow-hidden rounded-2xl border border-slate-200 bg-brand-paper p-8 hover:border-brand-teal/40 transition-colors duration-300"
            >
              <span className="pointer-events-none select-none absolute -right-2 -bottom-7 font-display text-[7rem] leading-none text-brand-teal/[0.08]">
                {step.num}
              </span>
              <div className="relative">
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-teal">Step {step.num}</span>
                <h3 className="mt-2 font-display text-xl md:text-2xl text-brand-navy">{step.title}</h3>
                <p className="mt-3 text-base md:text-lg leading-relaxed text-slate-600 max-w-lg">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
